
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [showNotifications, setShowNotifications] = useState(false);

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 md:h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 md:space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/ac93b6a9-7f02-4a2c-93e2-1c7888622336.png" 
              alt="VTU App Logo" 
              className="h-8 w-8 md:h-10 md:w-10 object-contain"
            />
            <span className="text-lg md:text-xl font-bold text-gray-900">Dashboard</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-navy-600 font-medium transition-colors whitespace-nowrap">
              Dashboard
            </Link>
            <Link to="/recharge" className="text-gray-700 hover:text-navy-600 font-medium transition-colors whitespace-nowrap">
              Recharge
            </Link>
            <Link to="/bills" className="text-gray-700 hover:text-navy-600 font-medium transition-colors whitespace-nowrap">
              Bill Payments
            </Link>
            <Link to="/transactions" className="text-gray-700 hover:text-navy-600 font-medium transition-colors whitespace-nowrap">
              Transactions
            </Link>
            <Link to="/account" className="text-gray-700 hover:text-navy-600 font-medium transition-colors whitespace-nowrap">
              Account
            </Link>
          </div>

          {/* Right Side Icons */}
          <div className="flex items-center space-x-3 md:space-x-4">
            {/* Notifications */}
            <div className="relative">
              <Link 
                to="/notifications"
                className="relative p-2 text-gray-600 hover:text-navy-600 transition-colors cursor-pointer block md:hidden"
              >
                <i className="ri-notification-3-line text-xl"></i>
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </Link>
              <button 
                onClick={() => setShowNotifications(!showNotifications)}
                className="relative p-2 text-gray-600 hover:text-navy-600 transition-colors cursor-pointer hidden md:block"
              >
                <i className="ri-notification-3-line text-2xl"></i>
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button>

              {showNotifications && (
                <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 py-2 hidden md:block">
                  <div className="px-4 py-2 border-b border-gray-200">
                    <h3 className="font-semibold text-gray-900">Notifications</h3>
                  </div>
                  <Link to="/notifications" className="block px-4 py-3 hover:bg-gray-50 cursor-pointer">
                    <p className="text-sm font-medium text-gray-900">Transaction Successful</p>
                    <p className="text-xs text-gray-600 mt-1">Your airtime recharge was successful</p>
                  </Link>
                  <Link to="/notifications" className="block px-4 py-3 hover:bg-gray-50 cursor-pointer">
                    <p className="text-sm font-medium text-gray-900">New Offer Available</p>
                    <p className="text-xs text-gray-600 mt-1">Get 20% bonus on your next recharge</p>
                  </Link>
                  <Link to="/notifications" className="block px-4 py-2 text-center text-navy-600 text-sm font-medium hover:bg-gray-50">
                    View all notifications
                  </Link>
                </div>
              )}
            </div>

            {/* Profile - Desktop only */}
            <Link to="/account" className="hidden md:flex items-center space-x-2 cursor-pointer">
              <div className="w-9 h-9 bg-gradient-to-br from-navy-500 to-cyan-600 rounded-full flex items-center justify-center">
                <span className="text-white font-semibold text-sm">JD</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
